async function wait(ms){
  return new Promise(resolve=>setTimeout(resolve, ms))
}

// audio
function playAudio(audio){
  return new Promise(res=>{
    audio.play().then().catch(e=> {
      console.error('catch during auto audio play', e)
      res() // ensure the promise resolves even if we get a source error
    })
    audio.onended = res
  })
}

export{wait, playAudio}